let modalHandlerInstance = null;

export function setModalHandlerInstance(handler) {
  modalHandlerInstance = handler;
}

export function getModalHandler() {
  if (!modalHandlerInstance) {
    throw new Error("Modal handler instance not set yet");
  }
  return modalHandlerInstance;
}
